export const TEMPLATES_PATH = '/admin/templates';
export const BASELINE_TEMPLATES_PATH = `${TEMPLATES_PATH}/baseline`;
export const NEW_BASELINE_TEMPLATE_PATH = `${BASELINE_TEMPLATES_PATH}/new`;
